window.DASHBOARD_MAP = {
    options: {},
    map: undefined,
    init: function(options) {
        _.extend(window.DASHBOARD_MAP.options, options);
        window.DASHBOARD_MAP.initMap();
        window.MAPS.initFullScreen(window.DASHBOARD_MAP.map);
        window.DASHBOARD_MAP.initErrorHandling();
    },
    initMap: function()
    {
        window.DASHBOARD_MAP.map = L.map('drive-dashboard-map', {

        }).setView([51.606802,-0.240155], 11.5);

        // Add the streets
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: 'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>',
            maxZoom: 18,
            id: 'openstreetmap.streets',
        }).addTo(window.DASHBOARD_MAP.map);
    },
    initErrorHandling: function () {
        window.DASHBOARD_MAP.map.on('routingerror', function (e) {
            new Noty({
                type: "error",
                text: `Routing Errorz: ${e.error}`,
            }).show();
        });
    },
    // Align the map to best display the visible subdivisions. Does nothing if there
    // are no visible subdivision.
    fitSubdivisionBounds: function(){
        var promise = new Promise(function(resolve, reject){
            // We want to resolve after the map is finished updating.
            // so add a temporary listener which we remove before resolvnig.
            var afterViewResetLaunchPrint = function(){
                console.log('afterViewResetLaunchPrint');
                window.DASHBOARD_MAP.map.off('viewreset', afterViewResetLaunchPrint);
                resolve();
            }

            var selectedSubdivisionBounds = [];
            $.each(driveDashboard.areaControl, function(index, areaControl){
                if(areaControl.polygon.type === "subdivision") {
                    selectedSubdivisionBounds.push(areaControl.control.getBounds())
                }
            });
            if (selectedSubdivisionBounds.length > 0) {
                // Center the map where there are no roads - in the middle of the atlantic. This
                // ensures we definitly move and so trigger the viewreset event.
                window.DASHBOARD_MAP.map.setView(L.latLng(27, -47), 0, { animate: false });

                // If we are moving - we want to resolve after we've moved. So add an event listener.
                window.DASHBOARD_MAP.map.on('viewreset', afterViewResetLaunchPrint);
                window.DASHBOARD_MAP.map.fitBounds(
                    selectedSubdivisionBounds,
                    {
                        animate: false, // Visual nicities are just time wasting here
                        paddingTopLeft: L.point(0, 0),
                        paddingBottomRight: L.point(0, 0)
                    }
                );
            } else {
                console.log('There were no subdivisions to fit bounds to');
                // If there were no subdivisions to focus on we can
                // resolve safely.
                resolve();
            }
        });
        return promise;

    }
}
